export default __webpack_public_path__ + "static/media/section-2-img.fcfc690d.png";